import * as UI from '@brewlogix/blx-ui'
import classNames from 'classnames'
import React from 'react'
import { srmTerms } from 'src/util/constants'
import { deKebab } from 'src/util/helpers'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import { parseLiquidColorSlug } from '../../util/helpers/parseLiquidColorSlug'
import Field from '../Field'

const SRM: React.FC = () => {
    const { productData, srm, color } = useBrewDetailStore()

    const parseColorLabel = (color: string) => {
        if (color === 'fruity-fruity') {
            return 'Fruity'
        } else {
            const label = deKebab(color)
            return label?.charAt(0)?.toUpperCase() + label.slice(1)
        }
    }

    const avgSrm = Math.floor((productData?.style?.srmMin + productData?.style?.srmMax) / 2)
    const anySrm = srm ? (srm > 40 ? 40 : srm) : avgSrm
    const colorNumber = anySrm ? Number(anySrm.toString().split('-')) : null

    // Set display color conditionally depending on product type
    let displayColor
    let colorLabel
    if (productData?.__typename === 'Beer') {
        displayColor = 'srm-'
        displayColor +=
            productData?.srm ||
            Math.floor((productData?.style?.srmMin + productData?.style?.srmMax) / 2)
        colorLabel = srmTerms[colorNumber]
    } else {
        displayColor = productData?.color || null
        colorLabel = parseColorLabel(displayColor?.replace('flower-', '') || displayColor)
    }

    // Set classes and headings conditionally depending on product type
    const heading = anySrm || productData?.__typename === 'Beer' ? 'SRM' : 'Color'
    const colorClasses = classNames(
        `text-xs aspect-square text-white font-extrabold`,
        anySrm ? `bg-srm-${anySrm}` : '',
        !anySrm && !color ? 'bg-gray-100' : ''
    )

    // Create inline style if using color instead of srm since tailwind doesn't render class in time
    const style = {
        backgroundColor: color ? parseLiquidColorSlug(color) : null,
    }

    const noData = !anySrm && !color

    return (
        <Field gap='2' title={heading}>
            {!noData ? (
                <div className='w-fit flex items-center gap-2 py-1 pl-1 pr-4 bg-gray-100 rounded-full'>
                    <UI.Pill
                        size='sm'
                        theme='primary'
                        shape='full'
                        customClasses={colorClasses}
                        style={style}
                    >
                        {anySrm}
                    </UI.Pill>
                    <span className='text-dark text-sm'>{colorLabel}</span>
                </div>
            ) : (
                <span className='font-extrabold'>--</span>
            )}
        </Field>
    )
}

export default SRM
